<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/info-pool?id=4">信息交流</router-link></li>
                <li class="currentNode"><a>{{ title }}</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>信息交流</a></li>
                    <li><router-link to="/layout/info-pool?id=4" :class="{'active': id === '4'}">每日信息</router-link></li>
                    <li><router-link to="/layout/share-info?id=2" :class="{'active': id === '2'}">共享信息</router-link></li>
                    <li><router-link to="/layout/info-pool?id=3" :class="{'active': id === '3'}">专报信息</router-link></li>
                    <li><router-link to="/layout/info-pool?id=1" :class="{'active': id === '1'}">智库信息</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>{{ title }}</h3>
                    <ul class="info-pool-list">
                        <li class="info-data" v-for="infoPool in infoPoolList" :key="infoPool.ProjectId">
                        <!-- <h4 class="ellipsis_two"  @click="goDetail(infoPool)">{{ infoPool.Name }}</h4> -->
                        <h4 class="ellipsis_two">{{ infoPool.Name }}</h4>
                        <!-- <p class="ellipsis_four">{{ infoPool.ProjectDesc }}</p> -->
                        <div class="info-data-bar">
                            <div class="info-data-bar-lf  ellipsis_one">
                                
                                <!-- <div class="info-data-class"> -->
                                    <span class="info-pool-tag">{{ infoPool.Invest }}</span>
                                    <span>｜</span>
                                    <span class="news-date">{{ infoPool.CTime }}</span>
                                    <span v-if="id === '3'">｜</span>
                                    <span v-if="id === '3'" class="info-pool-tag">{{ infoPool.CompanyName }}</span>
                                <!-- </div> -->
                            </div>
                            <a class="info-pool-button"  @click="getProjectDown(infoPool)">会员免费下载</a>
                        </div>
                    </li>
                       
                        <!-- <li class="info-data">
                            <h4 @click="goDetail()">
                                <img src="@/assets/image/infoPool/pdf.png" />
                                <span>数据资源管理标准需求研究报告</span>
                            </h4>
                            <p>
                                将人工智能进行拆解再流程重构的农业AI大脑，人工：可根据客户的本地化城乡差异内容进行人工知识库补充且可以控制
                            </p>
                            <div class="info-data-bar">
                                <div>
                                    <span class="info-pool-tag">智库信息</span>
                                    <span class="news-date">1 小时前</span>
                                </div>
                                <a class="info-pool-button" @click="getProjectDown">会员免费下载</a>
                            </div>
                        </li>
                        <li class="info-data">
                            <h4 @click="goDetail()">
                                <img src="@/assets/image/infoPool/pdf.png" />
                                <span>数据资源管理标准需求研究报告</span>
                            </h4>
                            <p>
                                将人工智能进行拆解再流程重构的农业AI大脑，人工：可根据客户的本地化城乡差异内容进行人工知识库补充且可以控制
                            </p>
                            <div class="info-data-bar">
                                <div>
                                    <span class="info-pool-tag">智库信息</span>
                                    <span class="news-date">1 小时前</span>
                                </div>
                                <a class="info-pool-button">会员免费下载</a>
                            </div>
                        </li> -->
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            title=""
            :visible.sync="downloadDialogVisible"
            width="416px">
            <h3><i class="el-icon-warning-outline" style="color:#E6A23C;margin-right: 10px;margin-bottom:10px;"></i>{{ downloadDialogTitle }}</h3>
            <p style="padding-left:30px;">{{ downloadDialogContent }}</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="downloadDialogVisible = false" size="medium">取 消</el-button>
                <el-button type="primary" @click="goLogin()" size="medium">去登录</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getProjectList,
    getProjectDown
} from '@services/indexService.js'
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    name: '',
    data() {
        return {
            downloadUrl: '',
            id: '',// 所有0，智库信息1，批示专报信息2，专报信息3，一般信息4
            title: '',    
            infoPoolList:[],
            total: 0,
            currentPage: 1,
            pageSize: 8,        
            downloadDialogVisible: false,
            downloadDialogTitle: '请登录会员，上传专报信息后，免费下载',
            downloadDialogContent: '会员每上传1条专报信息，可下载5条专报信息'
        };
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
    },
    created() {
        this.id = this.$route.query.id;
        this.traverseTitle();
        this.getProjectList();
    },
    methods: {
        traverseTitle() {
            if (this.id === '1'){
                this.title = "智库信息";
                this.downloadDialogTitle = '登录会员，免费下载';
                this.downloadDialogContent = '';
            } else if (this.id === '2') {
                this.title = "共享信息";
            }else if (this.id === '3') {
                this.title = "专报信息";
                this.downloadDialogTitle = '请登录会员，上传专报信息后，免费下载';
                this.downloadDialogContent = '会员每上传1条专报信息，可下载5条专报信息';
            } else {
                this.title = "每日信息";
                this.downloadDialogTitle = '登录会员，免费下载';
                this.downloadDialogContent = '';
            }
        },
        getProjectList() {
            let param = {
                current: this.currentPage,
                size: this.pageSize,
                type: this.id,
            };
            getProjectList(param).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.infoPoolList = [...res.Data];
                    this.total = res.Count;
                    console.log(this.total);
                } else {
                    this.infoPoolList = [];
                    this.$message.error("信息交流请求失败");
                }
            })
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/info-pool-detail',
                query: {
                    id: data.ProjectId
                }
            });
            window.open(newUrl.href, '_blank');
        },
        getProjectDown(data) {
            let accountId = getCookie('accountId');
            if (!accountId) {
                this.downloadDialogVisible = true;
                return;
            }
            let params = {
                id: data.ProjectId,
                accountid: this.accountId,
            };
            getProjectDown(params).then((res) => {
                // console.log(res);
                if (res.Code == 1) {
                    this.downloadUrl = res.Data;
                    window.open(this.downloadUrl, '_blank');
                } else {
                    this.$message.error(res.Message);
                }
            });
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getProjectList();
        },
        goLogin() {
            this.downloadDialogVisible = false;
            this.$router.push({
              path: '/layout/login'  
            });
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.id = to.query.id + '';
                this.getProjectList()
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        }
    }
};
</script>

<style scoped>
.page-content {
    padding: 30px 40px;
}
.page-content h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
}
.info-pool-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-top:20px;
    padding-bottom: 10px;
}
.info-data {
    width: 456px;
    border-left: 1px solid #E5E5E5;
    border-bottom: 1px solid #E5E5E5;
    margin-right: 20px;
    margin-bottom: 20px;
}
.info-pool-list .info-data:nth-child(2n) {
    margin-right: 0px;
}
.info-data h4 {
    /* cursor: pointer; */
}
.info-data h4:hover{
    /* color: #116EBA; */
}
.info-data-bar-lf  {
    margin-right:20px;
}
</style>